/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createConfigsSlice = (set) => ({
  storeId: null,
  loadingConfigs: true,
  loadingLockersInfo: false,
  devolutionPageConfigs: null,
  storeConfigs: null,
  order: null,
  lockersInfo: null,
  integrationStatus: null,
  setStoreId: (storeId) => {
    set(
      produce((draft) => {
        draft.storeId = storeId;
      }),
    );
  },
  setLoadingConfigs: (loadingConfigs) => {
    set(
      produce((draft) => {
        draft.loadingConfigs = loadingConfigs;
      }),
    );
  },
  setConfigs: (configs) => {
    set(
      produce((draft) => {
        draft.devolutionPageConfigs = configs.devolutionPageConfigs;
        draft.storeConfigs = configs.storeConfigs;
        draft.order = configs.order;
        draft.lockersInfo = configs.lockersInfo;
        draft.integrationStatus = configs.integrationStatus;
      }),
    );
  },
  setLockersInfo: (lockersInfo) => {
    set(
      produce((draft) => {
        draft.lockersInfo = lockersInfo;
      }),
    );
  },
  setLoadingLockersInfo: (loadingLockersInfo) => {
    set(
      produce((draft) => {
        draft.loadingLockersInfo = loadingLockersInfo;
      }),
    );
  },
  setOrderAsMethodSelected: (returnMethodIndex) => {
    set(
      produce((draft) => {
        draft.order.status = {
          index: 2,
        };
        draft.order.returnMethod = {
          index: returnMethodIndex,
        };
      }),
    );
  },
  setOrderAsApproved: ({ returnMethodIndex, info }) => {
    set(
      produce((draft) => {
        draft.order.status = {
          index: 3,
        };
        draft.order.returnMethod = {
          index: returnMethodIndex,
          info,
        };
      }),
    );
  },
});

const useConfigsStore = create(
  devtools(
    (...a) => ({
      ...createConfigsSlice(...a),
    }),
    { name: 'PublicSelectReturnMethodConfigsStore' },
  ),
);

export default useConfigsStore;
